module.exports = __webpack_public_path__ + "img/BINDI 2 RED.dc38d1f.svg";